module.exports = __webpack_public_path__ + "img/df76cfe.png";